
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {

    getAll(data=null) {
        const queryString = new URLSearchParams(data).toString();
        const url = `${API_URL}/inventory?${queryString}`; 
        return axios.get(url, { headers: authHeader() });
    },

    /* getAll(pageUrl=null) {
        const url = `${API_URL}/inventory?page=${pageUrl}`; 
        return axios.get(url, { headers: authHeader() });
    }, */
    getData(id) {
        return axios.get(`${API_URL}/inventory/${id}`, { headers: authHeader() });
    },
    getProductionDetails(id, page = null, options = {}) {
        const params = {};
        if (page) params.page = page;
        if (options && options.discounted !== undefined && options.discounted !== null) {
            params.discounted = options.discounted ? 1 : 0;
        }

        const queryString = new URLSearchParams(params).toString();
        const url = queryString
            ? `${API_URL}/inventory/${id}/production-details?${queryString}`
            : `${API_URL}/inventory/${id}/production-details`;

        return axios.get(url, { headers: authHeader() });
    },
    getPurchaseDetails(id, page = null) {
        const params = {};
        if (page) params.page = page;

        const queryString = new URLSearchParams(params).toString();
        const url = queryString
            ? `${API_URL}/inventory/${id}/purchase-details?${queryString}`
            : `${API_URL}/inventory/${id}/purchase-details`;

        return axios.get(url, { headers: authHeader() });
    },
    createData(data) {

        // Obtener el user_id desde el localStorage
        let userId = JSON.parse(localStorage.getItem('user'));

        // Validar el user_id
        if (!userId || !userId.id) {
            throw new Error("User ID no válido. Asegúrate de haber iniciado sesión.");
        }

        data.user_id = userId.id;
        
        return axios.post(`${API_URL}/inventory`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/inventory/${id}`, data, { headers: authHeader() });
    },
    setCatalogFlag(id, showInCatalog) {
        return axios.patch(`${API_URL}/inventory/${id}/catalog-flag`, { show_in_catalog: showInCatalog }, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/inventory/${id}`, { headers: authHeader() });
    },
    getVariants(id) {
        return axios.get(`${API_URL}/inventory/${id}/variants`, { headers: authHeader() });
    },
    saveVariants(id, variants) {
        return axios.post(`${API_URL}/inventory/${id}/variants`, { variants }, { headers: authHeader() });
    },
    deleteVariant(id) {
        return axios.delete(`${API_URL}/inventory-variants/${id}`, { headers: authHeader() });
    },
    checkVariantUsage(id) {
        return axios.get(`${API_URL}/inventory-variants/${id}/check-usage`, { headers: authHeader() });
    },
    syncVariantBodegas(variantId, bodegas) {
        return axios.post(`${API_URL}/inventory-variants/${variantId}/bodegas`, { bodegas }, { headers: authHeader() });
    },

    exportCsv(search = null) {
        const params = search ? { search } : {};
        const queryString = new URLSearchParams(params).toString();
        const url = queryString ? `${API_URL}/inventory/export-csv?${queryString}` : `${API_URL}/inventory/export-csv`;
        return axios.get(url, {
            headers: authHeader(),
            responseType: 'blob',
        });
    },

    exportPdf(search = null) {
        const params = search ? { search } : {};
        const queryString = new URLSearchParams(params).toString();
        const url = queryString ? `${API_URL}/inventory/export-pdf?${queryString}` : `${API_URL}/inventory/export-pdf`;
        return axios.get(url, {
            headers: authHeader(),
            responseType: 'blob',
        });
    },

    importCsv(file) {
        const formData = new FormData();
        formData.append('file', file);
        return axios.post(`${API_URL}/inventory/import-csv`, formData, {
            headers: {
                Authorization: authHeader().Authorization || '',
            },
        });
    },

    uploadImage(id, file) {
        const formData = new FormData();
        formData.append('image', file);
        return axios.post(`${API_URL}/inventory/${id}/upload-image`, formData, {
            headers: {
                Authorization: authHeader().Authorization || '',
            },
        });
    },

    printBarcodeLabels(data) {
        return axios.post(`${API_URL}/inventory/print-barcode-labels`, data, {
            headers: authHeader(),
            responseType: 'blob',
        });
    },

    syncKubapp() {
        return axios.post(`${API_URL}/inventory/sync-kubapp`, {}, { headers: authHeader() });
    },
};